export interface AccountItem {
  Id: string;
  Name: string;
  Institution: string;
  Earmarks: { Type: string; Tooltip: string }[];
  Type: string;
  Value: number;
  LinkToTransactions: boolean;
  IsOrion: boolean;
  IsApexOrion?: boolean;
}

export interface AccountGroup {
  Name: string;
  Items: AccountItem[];
}

export const navigateToAccount = (item: AccountItem, clientId: string) => {
  if (item.IsOrion) {
    ADV.util.Router.go2('AccountPerformanceReporting', {
      accountId: item.Id,
      clientId,
      tabSlug: 'summary',
      isApex: item.IsApexOrion || false,
    });
    return;
  }

  if (item.Id) {
    ADV.util.Router.go2('Transactions', {
      accountId: item.Id,
      clientId,
    });
  }
};

export const isBalanceColumn = (descriptor: string) => descriptor === 'Balance';
